module.exports = __webpack_public_path__ + "img/empty-announcement.png?4c26855d";